import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import MinecraftModsSite from './MinecraftModsSite';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MinecraftModsSite />
  </React.StrictMode>
);
